export const colorClassByStatus = (status: string) => {
    switch (status?.toLowerCase()) {
        case 'finished':
        case 'delivered':
            return 'background-chip-success';
        case 'transmitted':
            return 'background-chip-primary'
        case 'read':
            return 'background-chip-info';
        case 'notdelivered':
        case 'failed':
        case 'error':
        case 'notanswered':
        case 'rejected':
            return 'background-chip-danger';
        default:
            return 'background-chip-warning';
    }
}

export const colorClassByDelivered = (item: any) => {
    if (item.delivered / item.total * 100 < 50) return 'color-danger';
    else if (item.delivered / item.total * 100 < 85) return 'color-warning';
    else if (item.delivered / item.total * 100 < 100) return 'color-success';
    else return 'color-success'
}

export const getUserChannel = () => {
    const allowedPages: any = localStorage.allowedPages
    const channels: string[] = [];
    const arrayChannels = allowedPages.split(",");
    arrayChannels.forEach((allowedPage: any) => {
        if (allowedPage.toLowerCase().includes('sms')) {
            channels.push('sms');
        } else if (allowedPage.toLowerCase().includes('viber')) {
            channels.push('viber');
        }
    });

    function uniq(channel: any) {
        return Array.from(new Set(channel));
    }

    return uniq(channels);
}

export function formatAsJson(value: unknown): string {
    try {
        return JSON.stringify(value, null, 2);
    } catch (e) {
        console.error(e);
        return '';
    }
}
